import { useEffect, useState } from "react";

import {
  Dataset,
  DatasetDetailResponse,
  H3Configuration
} from "@/types/dataset";

export const useH3Configuration = ({
  dataset,
  selectedDataset
}: {
  dataset?: Dataset;
  selectedDataset: DatasetDetailResponse | null;
}) => {
  const [h3Configuration, setH3Configuration] =
    useState<H3Configuration | null>(null);

  useEffect(() => {
    // Priority 1: use h3Configuration from dataset detail response if available
    if (dataset?.h3Configuration) {
      setH3Configuration(dataset.h3Configuration);
      return;
    }

    // Priority 2: use selectedDataset if dataset is not available
    if (
      !dataset &&
      selectedDataset?.source === "bvt" &&
      selectedDataset?.spatial_aggregation_type === "H3"
    ) {
      setH3Configuration({
        aggregationType: "AVG",
        resolution: selectedDataset?.grid_level || 8
      });
      return;
    }

    // Default
    setH3Configuration(null);
  }, [dataset, selectedDataset]);

  return { h3Configuration, setH3Configuration };
};
